import { gql } from "@/__generated__/gql";

export const STUDENT_LIST = gql(`
  query StudentList (
    $first: Int
    $after: String
    $last: Int
    $before: String
    $orgId: ID!
    $imageSize: Int = 400
    $argument: StudentListArgumentInput!
  ) {
    node(id: $orgId) {
      ... on Organization {
        id
        studentList(first: $first, after: $after, last: $last, before: $before, argument: $argument) {
          edges {
            node {
              id
              uuid
              profilePhoto {
                id
                url(size: $imageSize)
              }

              interests {
                edges {
                  node {
                    id
                    name
                  }
                }
              }
              majors {
                edges {
                  node {
                    id
                    name
                  }
                }
              }
              studentOrganizationStatus(organizationId: $orgId) {
                assignedCounselor {
                  firstName
                  lastName
                  name
                }
                bio
                cohortYear
                commitIndex
                commitIndexChangedOn
                commitPercentile
                crmUrl
                lastActiveAt
                email
                firstName
                name
                funnelState
                goingStatus
                highSchool
                joinType
                messagesSent
                lastName
                location
                phoneNumber
                studentType
                rise {
                  applyIndex
                  commitIndex
                  meltIndex
                  yieldIndex
                }
              }
            }
          }
          pageInfo {
            startCursor
            endCursor
            hasNextPage
            hasPreviousPage
          }
          totalCount
        }
      }
    }
  }
`);
